<template>
	<div class="user-related modal fade" id="modalRelated"  tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
	aria-hidden="true">
			<div class="modal-dialog" role="document">
					<div class="modal-content">
					<div class="modal-header">
							<h5 class="modal-title" id="exampleModalLabel">{{$t("message.login_faq_title")}}</h5>
					</div>
					<div class="modal-body">
							<h1>HOLAAA RAMON</h1>
					</div>
					<div class="modal-footer">
							<button data-vs-button="close-modal-related" type="button" class="btn btn-primary"
							data-dismiss="modal">{{$t("message.login_faq_close_button_text")}}</button>
					</div>
					</div>
			</div>
	</div>
</template>

<script>

export default {
	data() {
    return {
        modalShown: false
    }
	},
	methods: {
    toggleModal() {
        this.modalShown = !this.modalShown;
    }
	}
}

</script>

<style lang="scss" scoped>

</style>

